<template>
  <div class="popup">
    <div @click="togglePopup">
      <slot name="button"></slot>
    </div>
    <transition v-on:enter="popupEnter" v-on:leave="popupLeave">
      <div class="popup-wrapper" v-if="popupOpen">
        <div class="overlay" @click="togglePopup"></div>
        <div class="popup-content">
          <div class="head">
            <button class="close-button" @click="togglePopup"></button>
            <p class="title" v-show="title">
              {{ title }}
            </p>
          </div>
          <div class="content">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TweenLite from 'gsap'

export default {
  name: 'Popup',
  data () {
    return {
      popupOpen: false
    }
  },
  props: {
    autoOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    togglePopup () {
      this.popupOpen = !this.popupOpen
      if (!this.popupOpen) {
        this.$emit('closed')
      } else {
        this.$emit('opened')
      }
    },
    popupEnter (el, done) {
      const popup = el.querySelector('.popup-content')
      TweenLite.fromTo(popup, 0.4, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, onComplete: done, clearProps: 'all' })
    },
    popupLeave (el, done) {
      const popup = el.querySelector('.popup-content')
      TweenLite.to(popup, 0.4, { opacity: 0, onComplete: done, clearProps: 'all' })
    }
  },
  mounted () {
    this.popupOpen = this.autoOpen
  }
}
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 20;
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#5c6067, 0.75);
    z-index: 20;
  }
  .popup-content {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    z-index: 21;
    border-radius: $radius-sm;
    box-shadow: 2px 1px 20px rgba(0, 0, 0, 0.25);
    background-color: #fff;
    color: $primary-text-color;
    max-height: 100%;
    overflow-y: auto;
    .head {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      .close-button {
        background-image: url('../assets/icons/croix.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 25px;
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 50px;
        cursor: pointer;
        background-color: $secondary-color;
        border: none;
        z-index: 21;
        border-radius: $radius-sm;
      }
      .title {
        display: inline-block;
        text-align: center;
        font-size: 1.4rem;
        font-weight: 700;
        margin-bottom: 0;
        padding-top: 10px;
      }
    }
  }
}
</style>
